import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pdahr8yenn: FaireBrandEntity = {
  token: "b_pdahr8yenn",
  type: "brand",
  name: "Exotic Snacks Wholesale",
  avatarUrl:
    "https://cdn.faire.com/fastly/dbbb7a70b8a79dcd08bd37e5730db546a4f4d8c4546371c7563631f6c0a85756.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ee9c839a7ad6a36d561b29d3e1f881c5713681ae04179d19f7f6bf866bba431a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/dbbb7a70b8a79dcd08bd37e5730db546a4f4d8c4546371c7563631f6c0a85756.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ee9c839a7ad6a36d561b29d3e1f881c5713681ae04179d19f7f6bf866bba431a.png",
  location: "Queens, NY, USA",
  minimumOrderDollars: 140,
  rating: 2,
  reviewCount: 3,
  isInsider: true,
  description:
    "We were the first to DISTRIBUTE EXOTIC SNACKS in AMERICA so we know the best sellers with the best tastes. Our prices are firm because our product freshness is guaranteed. We offer warehouse PICKUP and SHIPPING all over AMERICA",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:45.175Z",
    importedBy: "entity-db-cli",
  },
};
